import { render, staticRenderFns } from "./AboutDetails.vue?vue&type=template&id=78fcc652&scoped=true"
import script from "./AboutDetails.vue?vue&type=script&lang=js"
export * from "./AboutDetails.vue?vue&type=script&lang=js"
import style0 from "./AboutDetails.vue?vue&type=style&index=0&id=78fcc652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fcc652",
  null
  
)

export default component.exports